import {take} from 'lodash';
import {Fragment, ReactElement, useCallback, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Button} from 'components';
import {TRANSLATION_KEYS} from 'locale/translation-keys';
import {renderUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.COMMON.BUTTONS;

type ChildrenProps<T> = {
    items: T[];
}

type Props<T> = {
    items: T[];
    pageSize?: number;
    showMoreBtnClassName?: string;
    children: (props: ChildrenProps<T>) => ReactElement;
}

export const ShowMoreItemsContainer = <T extends object>({
    items, pageSize = 100, showMoreBtnClassName, children
}: Props<T>) => {
    const {t} = useTranslation();
    const [itemsLimit, setItemsLimit] = useState(pageSize);
    const itemsToDisplay = useMemo(() => take(items, itemsLimit), [items, itemsLimit]);

    const addLimit = useCallback(() => {
        setItemsLimit((prev) => prev + pageSize);
    }, [pageSize]);

    return (
        <Fragment>
            {renderUtils.renderFunctionOrElementChildren(children, {
                items: itemsToDisplay
            })}
            {items.length > itemsLimit &&
                <div className='tw-text-center'>
                    <Button color='primary' className={showMoreBtnClassName} onClick={addLimit}>
                        {t(T_KEYS.SHOW_MORE)}
                    </Button>
                </div>}
        </Fragment>);
};